<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Shipping Line Booking Order</b-navbar-brand>
        </b-navbar>
        <banner-component
        v-if="ALLMODULE>0"
          :allModuleIdBanner="ALLMODULE ? ALLMODULE : ''"
          :jobSeriesBanner="JOBSERIES ? JOBSERIES : ''"
          :bannerClientName="mainEntryData.length > 0 ? mainEntryData[0].clientName : ''"
          :trackingId="trackingId != '' ? trackingId : ''"
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div class="mt-2">
              <!-- <b-button
                size="sm"
                variant="outline-info"
                :class="visible ? null : 'collapsed'"
                :aria-expanded="visible ? 'true' : 'false'"
                aria-controls="collapse-4"
                @click="visible = !visible"
              >Hide Details</b-button>-->
              <!-- <b-collapse id="collapse-4" v-model="visible" class="mt-2">
                <b-card class="HeaderMastBanner">
                  <md-layout gutter>
                    <md-layout md-flex="35">
                      <md-layout md-flex="100">
                        <b>
                          Client Name : {{mainEntryData[0].clientName}}
                          <br>
                        </b>
                        <b>Assignment No. : {{mainEntryData[0].ffExportFclSeries}}</b>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="25">
                      <b>
                        Stuffing Type : {{mainEntryData[0].stuffingType}}
                        <br>
                      </b>

                      <br>
                      <b>FF Activity : {{mainEntryData[0].containerInfo}}</b>
                    </md-layout>
                    <md-layout md-flex="40">
                      <md-layout md-flex="100">
                        <b>Shipping Line : {{mainEntryData[0].shippingLine}}</b>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                </b-card>
              </b-collapse> 
                <hr>-->
            </div>

            <!-- <md-layout gutter>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Assignment No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    name="assignmentNumber"
                    id="assignmentNumber"
                    v-model="BookingShippingLine.assignmentNumber"
                    disabled
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>-->

            <!-- <b-row>
              <b-col md="4">
                <md-layout md-flex="100">
                  <label>Booking Number *</label>
                  <model-list-select
                    :isDisabled="(($sessionsStorage.get('designation') != 'Admin' && BookingShippingLine.ffBookingId))?true:false"
                    v-if="BookingShippingLine.is_mainbookingFlow==2"
                    option-value="booking_no"
                    option-text="booking_no"
                    :list="ConsoleBookingList"
                    placeholder="Select Booking Number"
                    v-model="BookingShippingLine.bookingNumber"
                    @searchchange="SelectConsoleBooking"
                  ></model-list-select>
                  <b-form-input
                    v-else
                    :formatter="capitalizeAll"
                    name="bookingNumber"
                    id="bookingNumber"
                    v-model="BookingShippingLine.bookingNumber"
                  ></b-form-input>
          
                </md-layout>
                <span class="error" v-if="!BookingShippingLine.bookingNumber">{{
                  errorBooking.bookingNumber
                }}</span>
              </b-col>
              <b-col md="4">
                <div class="mobile-btn-booking">
                  <b-button size="sm" @click="showDocModal" variant="dark"
                    >Upload Booking Documents</b-button
                  >
                </div>
                <md-layout md-gutter v-if="uploadBookingStatus.length > 0">
                  <md-layout
                    md-flex="30"
                    v-for="(item, index) in uploadBookingStatus"
                    :key="index"
                  >
                    <a
                      :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                      target="_blank"
                      download
                      >View Old Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </md-layout>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>Booking Date</label>
                  <date-picker
                    :format="selectDateFormat"
                    lang="en"
                    id="bookingDate"
                    name="bookingDate"
                    v-model="BookingShippingLine.bookingDate"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>Booking Validity Date *</label>
                  <date-picker
                  :disabled="BookingShippingLine.is_mainbookingFlow==2?true:false"
                    :format="selectDateFormat"
                    lang="en"
                    id="validityBookingDate"
                    name="validityBookingDate"
                    v-model="BookingShippingLine.validityBookingDate"
                  ></date-picker>
                  <span
                    class="error"
                    v-if="!BookingShippingLine.validityBookingDate"
                    >{{ errorBooking.validityBookingDate }}</span
                  >
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>SI Cutoff Date & Time *</label>
                  <date-picker
                  
                    lang="en"
                    name="SICutOff"
                    id="SICutOff"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                    v-model="BookingShippingLine.SICutOff"
                  ></date-picker>
                  <span class="error" v-if="!BookingShippingLine.SICutOff">{{
                    errorBooking.SICutOff
                  }}</span>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>Gate open Date & Time</label>
  
                  <date-picker
                    v-model="BookingShippingLine.gateOpenDate"
                    lang="en"
                    name="gateOpenDate"
                    id="gateOpenDate"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="20">
                  <label>Gate Close Date & Time</label>
  
                  <date-picker
                    v-model="BookingShippingLine.gateCloseDate"
                    lang="en"
                    name="gateCloseDate"
                    id="gateCloseDate"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>Port Cut Off Date & Time</label>
  
                  <date-picker
                    v-model="BookingShippingLine.portCutDate"
                    lang="en"
                    name="portCutDate"
                    id="portCutDate"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>ENS Cut Off Date & Time</label>
                  <date-picker
                    v-model="BookingShippingLine.ENSCutDate"
                    lang="en"
                    name="ENSCutDate"
                    id="ENSCutDate"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>VGM CutOff Date & Time</label>
                  <date-picker
                    lang="en"
                    name="vgmCutOffDate"
                    id="vgmCutOffDate"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                    v-model="BookingShippingLine.vgmCutOffDate"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="25">
                  <label>Document CutOff Date & Time</label>
                  <date-picker
                    lang="en"
                    name="documentCutOffDate"
                    id="documentCutOffDate"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                    v-model="BookingShippingLine.documentCutOffDate"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2"></b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col md="5">
                <md-layout md-flex="100">
                  <label>Vessel Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="vesselName"
                    id="vesselName"
                    v-model="BookingShippingLine.vesselName"
                  ></b-form-input>
                </md-layout>
              </b-col>
              <b-col md="3">
                <md-layout md-flex="100">
                  <label>Voyage No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    name="voyageNo"
                    id="voyageNo"
                    v-model="BookingShippingLine.voyageNo"
                  ></b-form-input>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>Tentative Vessel ETA</label>
                  <date-picker
                    lang="en"
                    name="vesselEta"
                    id="vesselEta"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                    v-model="BookingShippingLine.vesselEta"
                  ></date-picker>
                </md-layout>
              </b-col>
              <b-col md="2">
                <md-layout md-flex="15">
                  <label>Tentative Vessel ETD</label>
                  <date-picker
                    lang="en"
                    name="vesselEtd"
                    id="vesselEtd"
                    type="datetime"
                    format="YYYY-MM-DD"
                    :minute-step="1"
                    v-model="BookingShippingLine.vesselEtd"
                  ></date-picker>
                </md-layout>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <md-layout md-flex="25">
                  <label for="bookingShipment">Booking Transhipment *</label>
                  <model-list-select
                    option-value="bookingShipmentVal"
                    option-text="bookingShipmentText"
                    :list="bookingShipmentList"
                    placeholder="Select"
                    v-model="BookingShippingLine.bookingShipment"
                  ></model-list-select>
  
                  <span
                    class="error"
                    v-if="!BookingShippingLine.bookingShipment"
                    >{{ errorBooking.bookingShipment }}</span
                  >
                </md-layout>
              </b-col>
            </b-row>
            <div
              class="gutr"
              
              id="TranshipmentDetail"
            >
              <b-row>
                <b-col md="12">
                  <h5>
                    <b-badge variant="">
                      Transhipment Details
                      <span
                        class="error"
                        v-if="tentativeDetailArray.length == 0"
                        >{{ bookingLengthError }}</span
                      >
                    </b-badge>
                  </h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <md-layout md-flex="30">
                    <label for="containerTypeId">Transhipment Port Name</label>
                    <model-list-select
                      @input="
                        getLocationList($event, 'Sea_Port', 'portMasterList')
                      "
                      @searchchange="
                        getLocationList($event, 'Sea_Port', 'portMasterList')
                      "
                      option-value="pickupId"
                      option-text="pickupLocation"
                      :list="portList"
                      placeholder="Select Port Name"
                      v-model="TranshipmentDetail.tentativePortId"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!TranshipmentDetail.tentativePortName"
                      >{{ errorList.tentativePortName }}</span
                    >
                  </md-layout>
                </b-col>
                <b-col md="3">
                  <md-layout md-flex="15">
                    <label style="width:100%;">ETA DATE</label>
                    <date-picker
                      :format="selectDateFormat"
                      v-model="TranshipmentDetail.etaDate"
                      lang="en"
                      id="etaDate"
                      name="etaDate"
                    ></date-picker>

                    <span class="error" v-if="!TranshipmentDetail.etaDate">{{
                      errorList.etaDate
                    }}</span>
                  </md-layout>
                </b-col>
                <b-col md="2">
                  <md-layout md-flex="15">
                    <label>ETD DATE</label>
                    <date-picker
                      :format="selectDateFormat"
                      v-model="TranshipmentDetail.etdDate"
                      lang="en"
                      id="etdDate"
                      name="etdDate"
                    ></date-picker>
                    <span class="error" v-if="!TranshipmentDetail.etdDate">{{
                      errorList.etdDate
                    }}</span>
                  </md-layout>
                </b-col>
                <b-col md="2">
                  <md-layout md-flex="20" style="margin-top: 40px">
                    <b-button
                      variant="info"
                      size="sm"
                      @click="addTentativeDetail"
                      id="addButtonLoader"
                      >{{
                        editIndex == "" &&
                        (editIndex != "0" || editIndex != 0) &&
                        TranshipmentDetail.ffBookingTranshipmentId == ""
                          ? "Add"
                          : "Edit"
                      }}
                      Transhipment</b-button
                    >
                    <md-spinner
                      md-indeterminate
                      id="loader"
                      style="display: none"
                    ></md-spinner>
                  </md-layout>
                </b-col>
              </b-row>
            </div> -->

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Booking Number *</label>
                  <!-- {{mainEntryData[0].shipmentType}} -->
                  <!-- {{BookingShippingLine}} -->
                  <!-- :isDisabled="BookingShippingLine.ffBookingId !=null || BookingShippingLine.ffBookingId !=undefined ||BookingShippingLine.ffBookingId !='null'||BookingShippingLine.ffBookingId !='undefined'||BookingShippingLine.ffBookingId !=''" -->

                  <model-list-select
                    :isDisabled="
                      viewPagePref==1
                        ? true
                        : mainEntryData[0].is_booking_updated == '1'
                        ? false
                        : $sessionsStorage.get('designation') != 'Admin' &&
                          BookingShippingLine.ffBookingId
                        ? true
                        : false
                    "
                    v-if="BookingShippingLine.is_mainbookingFlow == 2"
                    option-value="booking_no"
                    option-text="booking_no"
                    :list="ConsoleBookingList"
                    placeholder="Select Booking Number"
                    v-model="BookingShippingLine.bookingNumber"
                    @searchchange="SelectConsoleBooking"
                  ></model-list-select>
                  <b-form-input
                    v-else
                    :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    name="bookingNumber"
                    id="bookingNumber"
                    v-model="BookingShippingLine.bookingNumber"
                  ></b-form-input>
                  <!-- && mainEntryData.shipmentType =='Sea_Shipment' -->

                  <!-- {{BookingShippingLine.bookingNumber}} -->
                  <!-- @change="SelectConsoleBooking" -->
                  <!-- ConsoleBookingList -->
                  <!-- @input="(e) => $emit('SelectConsoleBooking', e.target.value)" -->
                </md-layout>

                <span class="error" v-if="!BookingShippingLine.bookingNumber">{{
                  errorBooking.bookingNumber
                }}</span>
              </md-layout>
              <!-- <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-input-container>
                  <label>Upload Booking Document</label>
                  <md-file
                    name="uploadBooking"
                    id="uploadBooking"
                    v-model="BookingShippingLine.uploadBooking"
                    @selected="onFileChangeCargo"
                    multiple
                  ></md-file>
                </md-input-container>
              </md-layout> -->
            </md-layout>
            <div class="mt-2">
              <b-button
                :disabled="viewPagePref==1"
                size="sm"
                @click="showDocModal"
                variant="dark"
                >Upload Booking Documents</b-button
              >
            </div>
            <md-layout md-gutter v-if="uploadBookingStatus.length > 0">
              <md-layout
                :disabled="viewPagePref==1"
                md-flex="30"
                v-for="(item, index) in uploadBookingStatus"
                :key="index"
              >
                <a
                  :href="`${docURL}/FF_Sea_Export_Uploads/` + item"
                  target="_blank"
                  download
                  >View Old Document - {{ index + 1 }}</a
                >
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="15">
                <label>Booking Release Date *</label>
                <date-picker
                :disabled="viewPagePref==1"
                  :format="selectDateFormat"
                  lang="en"
                  id="bookingDate"
                  name="bookingDate"
                  v-model="BookingShippingLine.bookingDate"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.bookingDate">
                  {{ errorBooking.bookingDate }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Booking Validity Date *</label>
                <date-picker
                  :disabled="(viewPagePref==1 || BookingShippingLine.is_mainbookingFlow == 2) ? true : false"
                  :format="selectDateFormat"
                  lang="en"
                  id="validityBookingDate"
                  name="validityBookingDate"
                  v-model="BookingShippingLine.validityBookingDate"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.validityBookingDate">
                  {{ errorBooking.validityBookingDate }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>SI Cutoff Date *</label>
                <!-- :disabled="BookingShippingLine.is_mainbookingFlow==2?true:false" -->
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="SICutOff"
                  id="SICutOff"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.SICutOff"
                ></date-picker>
                <span class="error" v-if="!BookingShippingLine.SICutOff">
                  {{ errorBooking.SICutOff }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Gate/Forwarding Open Date</label>

                <date-picker
                :disabled="viewPagePref==1"
                  v-model="BookingShippingLine.gateOpenDate"
                  lang="en"
                  name="gateOpenDate"
                  id="gateOpenDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>

                <span class="error" v-if="!BookingShippingLine.gateOpenDate">
                  {{ errorBooking.gateOpenDate }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <label>Gate/Forwarding Close Date</label>

                <date-picker
                :disabled="viewPagePref==1"
                  v-model="BookingShippingLine.gateCloseDate"
                  lang="en"
                  name="gateCloseDate"
                  id="gateCloseDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="15">
                <label>Port Cut Off Date</label>

                <date-picker
                :disabled="viewPagePref==1"
                  v-model="BookingShippingLine.portCutDate"
                  lang="en"
                  name="portCutDate"
                  id="portCutDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <!-- <md-layout md-flex="15">
                <label>ENS Cut Off Date </label>

                <date-picker
                  v-model="BookingShippingLine.ENSCutDate"
                  lang="en"
                  name="ENSCutDate"
                  id="ENSCutDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                ></date-picker>
              </md-layout> -->
              <!-- <md-layout md-flex="5"></md-layout> -->
              <md-layout md-flex="15">
                <label>VGM CutOff Date *</label>
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="vgmCutOffDate"
                  id="vgmCutOffDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vgmCutOffDate"
                ></date-picker>

                <span class="error" v-if="!BookingShippingLine.vgmCutOffDate">
                  {{ errorBooking.vgmCutOffDate }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>TR CutOff Date *</label>
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="documentCutOffDate"
                  id="documentCutOffDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.documentCutOffDate"
                ></date-picker>

                <span class="error" v-if="!BookingShippingLine.documentCutOffDate">
                  {{ errorBooking.documentCutOffDate }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Vessel Sail Date *</label>
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="VesselSailDate"
                  id="VesselSailDate"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vessel_sale_start_date"
                  @input="
                    ChangeDate(
                      BookingShippingLine.vessel_sale_start_date,
                      BookingShippingLine.SICutOff
                    )
                  "
                ></date-picker>

                <span class="error" v-if="!BookingShippingLine.vessel_sale_start_date">
                  {{ errorBooking.vessel_sale_start_date }}
                </span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Handover CutOff Date *</label>
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="handover_cutoff_date"
                  id="handover_cutoff_date"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.handover_cutoff_date"
                ></date-picker>

                <span class="error" v-if="!BookingShippingLine.handover_cutoff_date">
                  {{ errorBooking.handover_cutoff_date }}
                </span>
              </md-layout>
            </md-layout>

            <md-layout gutter class="labelMargtop">
              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Vessel Name</label>
                  <b-form-input
                  :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    name="vesselName"
                    id="vesselName"
                    v-model="BookingShippingLine.vesselName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Voyage No.</label>
                  <b-form-input
                  :disabled="viewPagePref==1"
                    :formatter="capitalizeAll"
                    name="voyageNo"
                    id="voyageNo"
                    v-model="BookingShippingLine.voyageNo"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Tentative Vessel ETA</label>
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="vesselEta"
                  id="vesselEta"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vesselEta"
                ></date-picker>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Tentative Vessel ETD</label>
                <date-picker
                :disabled="viewPagePref==1"
                  lang="en"
                  name="vesselEtd"
                  id="vesselEtd"
                  type="date"
                  format="YYYY-MM-DD"
                  :minute-step="1"
                  v-model="BookingShippingLine.vesselEtd"
                ></date-picker>
              </md-layout>
            </md-layout>

            <!-- <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="25">
                <label for="bookingShipment">Booking Transhipment *</label>
                <model-list-select
                  option-value="bookingShipmentVal"
                  option-text="bookingShipmentText"
                  :list="bookingShipmentList"
                  placeholder="Select"
                  v-model="BookingShippingLine.bookingShipment"
                ></model-list-select>

                <span
                  class="error"
                  v-if="!BookingShippingLine.bookingShipment"
                  >{{ errorBooking.bookingShipment }}</span
                >
              </md-layout>
            </md-layout> -->

            <!-- <div
              class="gutr"
              v-if="BookingShippingLine.bookingShipment == 'yes'"
              id="TranshipmentDetail"
            >
              <b-card>
                <md-layout md-gutter>
                  <h5>
                    <b-badge variant="">
                      Transhipment Details
                      <span
                        class="error"
                        v-if="tentativeDetailArray.length == 0"
                        >{{ bookingLengthError }}</span
                      >
                    </b-badge>
                  </h5>
                </md-layout>

                <md-layout md-gutter>
                  <md-layout md-flex="30">
                    <label for="containerTypeId">Transhipment Port Name</label>
                    <model-list-select
                      @input="
                        getLocationList($event, 'Sea_Port', 'portMasterList')
                      "
                      @searchchange="
                        getLocationList($event, 'Sea_Port', 'portMasterList')
                      "
                      option-value="pickupId"
                      option-text="pickupLocation"
                      :list="portList"
                      placeholder="Select Port Name"
                      v-model="TranshipmentDetail.tentativePortId"
                    ></model-list-select>
                    <span
                      class="error"
                      v-if="!TranshipmentDetail.tentativePortName"
                      >{{ errorList.tentativePortName }}</span
                    >
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>ETA DATE</label>
                    <date-picker
                      :format="selectDateFormat"
                      v-model="TranshipmentDetail.etaDate"
                      lang="en"
                      id="etaDate"
                      name="etaDate"
                    ></date-picker>

                    <span class="error" v-if="!TranshipmentDetail.etaDate">{{
                      errorList.etaDate
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>ETD DATE</label>
                    <date-picker
                      :format="selectDateFormat"
                      v-model="TranshipmentDetail.etdDate"
                      lang="en"
                      id="etdDate"
                      name="etdDate"
                    ></date-picker>
                    <span class="error" v-if="!TranshipmentDetail.etdDate">{{
                      errorList.etdDate
                    }}</span>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20" style="margin-top: 40px">
                    <b-button
                      variant="info"
                      size="sm"
                      @click="addTentativeDetail"
                      id="addButtonLoader"
                      >{{
                        editIndex == "" &&
                        (editIndex != "0" || editIndex != 0) &&
                        TranshipmentDetail.ffBookingTranshipmentId == ""
                          ? "Add"
                          : "Edit"
                      }}
                      Transhipment</b-button
                    >
                    <md-spinner
                      md-indeterminate
                      id="loader"
                      style="display: none"
                    ></md-spinner>
                  </md-layout>
                </md-layout>

                <table
                  v-if="tentativeDetailArrayList.length > 0"
                  id="ffBookingTentative"
                  class="table table-bordered mt-3"
                >
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Transhipment Port Name</th>
                      <th>Arrival Time</th>
                      <th>Departure Time</th>

                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in tentativeDetailArrayList"
                      :key="index"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.tentativePortName }}</td>
                      <td>{{ item.etaDate | moment }}</td>
                      <td>{{ item.etdDate | moment }}</td>

                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="viewEdit(item.ffBookingTranshipmentId, index)"
                        >
                          <md-icon>edit</md-icon>
                        </md-button>
                      </td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="
                            DeleteList(item.ffBookingTranshipmentId, index)
                          "
                        >
                          <md-icon>delete_sweep</md-icon>
                        </md-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-card>
            </div> -->

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="35">
                <b-button
                  class="mt-4"
                  variant="primary"
                  @click="addBookingDetail"
                  id="addButtonLoader1"
                  >Save & Proceed to Execution</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader1"
                  style="display: none"
                ></md-spinner>
              </md-layout>
            </md-layout>

            <span class="error pull-right" v-if="Created">
              <b> {{ Created }} </b>
            </span>
            <br />

            <span class="error pull-right" v-if="Updated">
              <b> {{ Updated }} </b>
            </span>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <div v-if="ALLMODULE">
      <b-modal
        size="xl"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        title=""
      >
        <div>
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose6"
      ref="addPop6"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop2"
      @close="onClose"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
// import BannerComponent from "../allModuleForm/bannerComponent.vue";
import BannerComponent from "../allModuleForm/trackingBannerComponent.vue";

import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import axios from "axios";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus, GlobalGetLocation } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";

export default {
  beforeMount() {
    if (
      globalPermissionStatus("Sea Freight") &&
      this.$sessionsStorage.get("editExportFCLId") != undefined &&
      this.$sessionsStorage.get("editExportFCLId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ffBooking");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  beforeDestroy() {},
  props: ["postTitle"],
  data() {
    return {
      viewPagePref: this.$sessionsStorage.get("user_view_page_pref"),
      selectDateFormat,
      visible: true,
      trackingId: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      // bookingShipmentName: [
      //   {
      //     bookingShipmentVal: "yes",
      //     bookingShipmentText: "Yes",
      //   },
      //   {
      //     bookingShipmentVal: "no",
      //     bookingShipmentText: "No",
      //   },
      // ],
      value12: "",
      ConsoleBookingList: [],
      BookingShippingLine: {
        ffBookingId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        assignmentNumber: "",
        bookingNumber: "",
        console_booking_id: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        // ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "no",
        stuffingType: "",
        vesselEta: null,
        vesselEtd: null,
        vgmCutOffDate: "",
        documentCutOffDate: "",
        vessel_sale_start_date: "",
        handover_cutoff_date: "",
        voyageNo: "",
        is_bookingFlow: "",
        is_mainbookingFlow: "",
      },

      Created: "",
      Updated: "",

      portMasterList: [],
      mainEntryData: [],
      ALLMODULE: "",
      JOBSERIES: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },

      TranshipmentDetail: {
        ffBookingTranshipmentId: "",
        tentativePortId: "",
        tentativePortName: "",
        etaDate: "",
        etaTime: "",
        etdDate: "",
        etdTime: "",
      },
      tentativeDetailArray: [],
      errorList: {
        tentativePortId: "",
        etaDate: "",
        etdDate: "",
      },
      deleteId: "",
      validateTrans: true,
      arrayError: [
        "Select  Transhipment port Name",
        "Select ETA Date",
        "Select ETA Date",
      ],
      errorBooking: {
        bookingNumber: "",
        validityBookingDate: "",
        SICutOff: "",
        bookingDate: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        handover_cutoff_date: "",
        vessel_sale_start_date: "",
      },
      bookingLengthError: "",
      arrayBookingError: [
        "Enter Booking Number",
        "Enter Validity Booking Number",
        "Enter SI Cut off",
        "Enter Booking Release Date",
        "Enter VGM Cut off Date",
        "Enter TR Cut off Date",
        "Enter Handover Cut off Date",
        "Enter Vessel sail Date",
      ],
      editIndex: "",
    };
  },

  mounted() {},
  watch: {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    DocForm,
    BannerComponent,
  },
  computed: {
    uploadBookingStatus() {
      return this.BookingShippingLine.uploadBooking != ""
        ? this.BookingShippingLine.uploadBooking.split(",")
        : [];
    },
    tentativeDetailArrayList() {
      return this.tentativeDetailArray;
    },
    portList() {
      return this.portMasterList;
    },

    // bookingShipmentList() {
    //   return this.bookingShipmentName;
    // },
  },
  methods: {
    ChangeDate(vessel_sale_start_date, sicutoff) {
      if (
        vessel_sale_start_date != undefined ||
        vessel_sale_start_date != null ||
        vessel_sale_start_date != ""
      ) {
        const now = new Date(vessel_sale_start_date);

        const handover_cutoff_date = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - 10
        );
        this.BookingShippingLine.handover_cutoff_date = handover_cutoff_date;

        // = "1969-12-22" || "1969-12-24" || "1970-01-01" || undefined || null ? '' :

        const vgmCutOffDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - 8
        );
        this.BookingShippingLine.vgmCutOffDate = vgmCutOffDate;

        const documentCutOffDate = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate() - 8
        );
        this.BookingShippingLine.documentCutOffDate = documentCutOffDate;

        if (sicutoff == "") {
          const SICutOff = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 8);
          this.BookingShippingLine.SICutOff = SICutOff;
        }
      } else {
        this.BookingShippingLine.handover_cutoff_date = "";
        this.BookingShippingLine.vgmCutOffDate = "";
        this.BookingShippingLine.documentCutOffDate = "";
      }
    },

    SelectConsoleBooking(items) {
      let validity_end = "";
      // this.ConsoleBookingList.map((x) => {
      //   if (items == x.booking_no) {
      //     validity_end = x.validity_end;
      //   }
      // });
      let booking_id = "";
      let bookingDate = "";
      let sicutoff = "";
      let vesselEta = "";
      let vesselEtd = "";
      let voyageNo = "";
      let vesselName = "";
      let vessel_sale_start_date = "";

      for (let i = 0; i < this.ConsoleBookingList.length; i++) {
        const item = this.ConsoleBookingList[i];
        if (items == item.booking_no) {
          booking_id = item.booking_id;
          bookingDate = item.validity_start;
          validity_end = item.validity_end;
          sicutoff = item.sicutoff;
          vesselEta = item.vesselEta;
          vesselEtd = item.vesselEtd;
          voyageNo = item.voyageNo;
          vessel_sale_start_date = item.vessel_sale_start_date;
          vesselName = item.vesselName;
        }
      }

      this.BookingShippingLine.console_booking_id = booking_id;
      this.BookingShippingLine.bookingDate = bookingDate;
      this.BookingShippingLine.validityBookingDate = validity_end;
      // this.BookingShippingLine.SICutOff = sicutoff;

      this.BookingShippingLine.SICutOff =
        sicutoff == "1970-01-01" || sicutoff == undefined || sicutoff == null
          ? ""
          : sicutoff;
      this.BookingShippingLine.vesselEta =
        vesselEta == "1970-01-01" || vesselEta == undefined || vesselEta == null
          ? ""
          : vesselEta;
      this.BookingShippingLine.vesselEtd =
        vesselEtd == "1970-01-01" || vesselEtd == undefined || vesselEtd == null
          ? ""
          : vesselEtd;

      this.BookingShippingLine.voyageNo = voyageNo;
      this.BookingShippingLine.vessel_sale_start_date = vessel_sale_start_date;
      this.BookingShippingLine.vesselName = vesselName;

      this.ChangeDate(
        this.BookingShippingLine.vessel_sale_start_date,
        this.BookingShippingLine.SICutOff
      );
    },
    showDocModal() {
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    // autoENSDate() {
    //   this.BookingShippingLine.SICutOff = this.BookingShippingLine.ENSCutDate;
    // },
    onClose() {
      if (this.mainEntryData[0].newContainerFlow == "1") {
        if (this.BookingShippingLine.stuffingType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/newffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/newFFexecutionWareHouse",
          });
        }
      } else {
        if (this.BookingShippingLine.stuffingType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/ffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/ffexecutionWareHouse",
          });
        }
      }
    },
    onClose6(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "ff_booking_transhipment",
          tableId: "ffBookingTranshipmentId",
          isActive: "isDepartmentActive",
          statusKey: "isActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/deletePermanentStatus.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;

            this.getData();
            this.deleteId = "";
          })
          .catch((error) => {});
      }
    },
    viewEdit(id, index) {
      if (id == "") {
        this.editIndex = index;
        Object.keys(this.TranshipmentDetail).map((x) => {
          this.TranshipmentDetail[x] = this.tentativeDetailArray[index][x];
        });
      } else {
        let array = this.tentativeDetailArray.filter((x) => {
          return x.ffBookingTranshipmentId == id;
        });

        Object.keys(this.TranshipmentDetail).map((x) => {
          this.TranshipmentDetail[x] = array[0][x];
        });
      }
    },
    DeleteList(id, index) {
      if (id == "") {
        this.tentativeDetailArray.splice(index, 1);
      } else {
        this.deleteId = id;
        this.alert.content = "Are you sure you want to delete this data?";
        this.$refs["addPop6"].open();
      }
    },
    previousSalesView() {
      window.history.go(-1);
      // this.$router.push({
      //   path: "/freightForward/ffExportFcl",
      // });
    },
    validateTranshipment() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (this.TranshipmentDetail[x] == "") {
          this.errorList[x] = this.arrayError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    onFileChangeCargo() {
      let files = event.target.files || event.dataTransfer.files;
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);
        formData.append("staticFileName", "Sea_Export_BookingOrder");
        formData.append(
          "upload_dir_folderName",
          this.mainEntryData[0].ffExportFclSeries.replaceAll("/", "_")
        );
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          this.BookingShippingLine.uploadBooking = result.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    addBookingDetail() {
      this.BookingShippingLine["allModuleId"] = this.mainEntryData[0].allModuleId;

      let console_booking_id = "";
      // this.ConsoleBookingList.map((x) => {
      //   if(this.BookingShippingLine.bookingNumber == x.booking_no){
      //       console_booking_id = x.booking_id;
      //   }
      // }); //Open
      // let booking_id = this.ConsoleBookingList.filter(
      //   (item) => {
      //   console.log("this.BookingShippingLine item=>",item.booking_id);
      //   if(this.BookingShippingLine.bookingNumber == item.booking_no){
      //       return true;
      //   } else {
      //     return false;
      //   }
      // });

      // let booking_id = null;
      // for (let i = 0; i < this.ConsoleBookingList.length; i++) {
      //   const item = this.ConsoleBookingList[i];
      //   if(this.BookingShippingLine.bookingNumber == item.booking_no) {
      //     booking_id = item.booking_id
      //   }
      // }

      // this.BookingShippingLine.console_booking_id = console_booking_id; //Open
      // console.log("this.BookingShippingLine=>",this.BookingShippingLine); //Open
      //  console.log("this.booking_id=>",booking_id);
      // alert(console_booking_id);
      // console.log("this.BookingShippingLine=>",this.BookingShippingLine); //Open
      // return false;

      this.BookingShippingLine["transhipmentDetail"] = this.tentativeDetailArray;

      this.validateBooking();

      if (this.validateTrans != false) {
        $("#addButtonLoader1").css("display", "none");
        $("#loader1").css("display", "block");

        let options = {
          method: "POST",
          // url: `${URL_BASE}/Api_FFSeaExport/addBookingDetailTracking.php`,
          url: `${URL_BASE}/Api_FFSeaExport/addBookingDetailTrackingPV.php`,
          data: JSON.stringify(this.BookingShippingLine),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (this.mainEntryData[0].newContainerFlow == "1") {
                this.$sessionsStorage.set("editFFBookingId", data.ffBookingId);
                this.BookingShippingLine.ffBookingId = data.ffBookingId;
              }
              $("#loader1").css("display", "none");
              $("#addButtonLoader1").css("display", "block");

              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
                if (data.subscriptionId) {
                  this.alert.content = "Data Added Successfully & Subscription created";

                  this.getTrackingDetails();
                } else {
                  this.alert.content = "Data Added Successfully & " + data.trackingMsg;
                }
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              // this.$sessionsStorage.set(
              //   "editFFExecutionId",
              //   data.ffExecutionId
              // );
              this.$refs["addPop2"].open();
            }
          })
          .catch((error) => {});
      }
    },

    validateBooking() {
      let validate_new = true;
      Object.keys(this.errorBooking).map((x, index) => {
        if (this.BookingShippingLine[x] == "") {
          this.errorBooking[x] = this.arrayBookingError[index];
          validate_new = false;
        }
      });

      if (
        this.BookingShippingLine.bookingShipment == "yes" &&
        this.tentativeDetailArray.length == 0
      ) {
        this.bookingLengthError = "Select Atleast one transhipment";
        validate_new = false;
      } else {
        this.bookingLengthError = "";
      }

      if (!this.BookingShippingLine.bookingDate) {
        this.errorBooking.bookingDate = "Enter Booking Release Date";
        validate_new = false;
      }

      if (!this.BookingShippingLine.SICutOff) {
        this.errorBooking.SICutOff = "Enter SI Cut off";
        validate_new = false;
      }

      if (!this.BookingShippingLine.vessel_sale_start_date) {
        this.errorBooking.vessel_sale_start_date = "Enter Vessel Sail Date";
        validate_new = false;
      }

      if (!this.BookingShippingLine.handover_cutoff_date) {
        this.errorBooking.handover_cutoff_date = "Enter Handover Cut off";
        validate_new = false;
      }

      if (!this.BookingShippingLine.vgmCutOffDate) {
        this.errorBooking.vgmCutOffDate = "Enter VGM Cut off";
        validate_new = false;
      }

      if (!this.BookingShippingLine.documentCutOffDate) {
        this.errorBooking.documentCutOffDate = "Enter TR Cut off";
        validate_new = false;
      }

      if (validate_new == false) {
        this.validateTrans = false;
      } else {
        this.validateTrans = true;
      }
    },

    addTentativeDetail() {
      let array_new = this.portMasterList;

      var obj = {};
      this.validateTranshipment();

      if (
        this.$sessionsStorage.get("editFFBookingId") == "" ||
        this.$sessionsStorage.get("editFFBookingId") == undefined ||
        this.$sessionsStorage.get("editFFBookingId") == null
      ) {
        if (this.validateTrans != false) {
          let arrayPort = array_new.filter((x) => {
            return x.pickupId == this.TranshipmentDetail.tentativePortId;
          })[0];
          this.TranshipmentDetail.tentativePortName = arrayPort.pickupLocation;
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          var obj1 = {};
          Object.keys(this.TranshipmentDetail).map((x) => {
            obj1[x] = this.TranshipmentDetail[x];
            this.TranshipmentDetail[x] = "";
          });
          Object.keys(this.errorList).map((x) => {
            this.errorList[x] = "";
          });

          if (this.editIndex == "" && (this.editIndex != "0" || this.editIndex != 0)) {
            this.alert.content = "Data Added Successfully";

            this.tentativeDetailArray.push(obj1);
          } else {
            this.alert.content = "Data Updated Successfully";
            this.$refs["addPop"].open();
            this.tentativeDetailArray.splice(this.editIndex, 1);
            this.tentativeDetailArray.splice(this.editIndex, 0, obj1);
            this.editIndex = "";
          }
          setTimeout(function () {
            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
          }, 1000);
        }
      } else {
        this.TranshipmentDetail["ffBookingId"] = this.$sessionsStorage.get(
          "editFFBookingId"
        );
        if (this.validateTrans != false) {
          let arrayPort = array_new.filter((x) => {
            return x.pickupId == this.TranshipmentDetail.tentativePortId;
          })[0];
          this.TranshipmentDetail.tentativePortName = arrayPort.pickupLocation;
          $("#addButtonLoader").css("display", "none");
          $("#loader").css("display", "block");
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_FFSeaExport/addTranshipmentFFExport.php`,
            data: JSON.stringify(this.TranshipmentDetail),
            crossDomain: true,

            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId"),
            },
          };

          axios(options)
            .then((result) => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                console.log(data);
                if (data.msg == "Inserted Successfully") {
                  Object.keys(this.TranshipmentDetail).map((x) => {
                    obj[x] = this.TranshipmentDetail[x];
                    this.TranshipmentDetail[x] = "";
                  });
                  Object.keys(this.errorList).map((x) => {
                    this.errorList[x] = "";
                  });
                  obj["ffBookingTranshipmentId"] = data.ffBookingTranshipmentId;

                  this.tentativeDetailArray.push(obj);
                  this.alert.content = "Data Added Successfully";
                  this.$refs["addPop"].open();
                } else {
                  Object.keys(this.TranshipmentDetail).map((x) => {
                    this.TranshipmentDetail[x] = "";
                  });
                  Object.keys(this.errorList).map((x) => {
                    this.errorList[x] = "";
                  });
                  this.alert.content = "Data Updated Successfully";
                  this.$refs["addPop"].open();
                }

                setTimeout(function () {
                  $("#addButtonLoader").css("display", "block");
                  $("#loader").css("display", "none");
                }, 1000);

                // this.getData();
              }
            })
            .catch((error) => {});
        }
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#ffBookingTentative").DataTable();
      });
    },
    async getData() {
      this.doLoading();
      if (this.tentativeDetailArray.length == 1) {
        this.tentativeDetailArray = [];
      }

      let new_data = {
        exPage: "1",
        ffExecutionId: this.$sessionsStorage.get("editFFExecutionId"),
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId:
          this.$sessionsStorage.get("editFFBookingId") != "" &&
          this.$sessionsStorage.get("editFFBookingId") != undefined
            ? this.$sessionsStorage.get("editFFBookingId")
            : "",
      };

      let options = {
        method: "POST",
        // url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_NewV3.php`,
        url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_VP.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.editFFEX.length > 0) {
              // alert(data.editFFEX[0].is_mainbookingFlow);
              this.mainEntryData = data.editFFEX;
              this.ALLMODULE = data.editFFEX[0].allModuleId;
              this.JOBSERIES = data.editFFEX[0].ffExportFclSeries;
            }
            if (data.ConsoleBookingList.length > 0) {
              this.ConsoleBookingList = data.ConsoleBookingList;
            } else {
              this.ConsoleBookingList = [];
            }
            console.log("Priyanshu SIngh=>", data);

            this.Created = data.Created;
            this.Updated = data.Updated;

            this.portMasterList = data.LocationDetailsSEAPORT;
            if (data.ffBookingDetail.length > 0) {
              Object.keys(this.BookingShippingLine).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
              console.log(this.BookingShippingLine.ffBookingId);
            } else {
              this.BookingShippingLine.assignmentNumber =
                data.editFFEX[0].ffExportFclSeries;
            }
            this.BookingShippingLine.stuffingType = data.editFFEX[0].stuffingType;

            this.BookingShippingLine.is_mainbookingFlow =
              data.editFFEX[0].is_mainbookingFlow;

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }

            console.log(this.BookingShippingLine.bookingNumber);
            if (this.BookingShippingLine.bookingNumber) {
              this.SelectConsoleBooking(this.BookingShippingLine.bookingNumber);
            }
            this.getTrackingDetails();
            this.getSubscription();
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    getSubscription() {
      if (this.trackingId != "") {
        let payload = {
          subscriptionId: this.trackingId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Tracking/globalTracking.php`,
          data: JSON.stringify(payload),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            this.isLoading = false;
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              console.log("Result => ", JSON.parse(data.data));
              data.data = JSON.parse(data.data);
              if (data.data.containershipments.length > 0) {
                this.BookingShippingLine.vesselName = data.data.containershipments[0][
                  "leg1_vessel"
                ]
                  ? data.data.containershipments[0]["leg1_vessel"]["name"]
                  : this.BookingShippingLine.vesselName;
                this.BookingShippingLine.voyageNo = data.data.containershipments[0][
                  "leg1_voyage"
                ]
                  ? data.data.containershipments[0]["leg1_voyage"]
                  : this.BookingShippingLine.voyageNo;

                // this.BookingShippingLine.vesselEta = data.data.containershipments[0]["pol_arrival_planned_initial"]? data.data.containershipments[0]["pol_arrival_planned_initial"] : this.BookingShippingLine.vesselEta;
                // this.BookingShippingLine.vesselEtd = data.data.containershipments[0]["pol_vsldeparture_planned_initial"] ? data.data.containershipments[0]["pol_vsldeparture_planned_initial"]:this.BookingShippingLine.vesselEtd;
              }
            }
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("Err => ", error);
          });
      }
    },

    getTrackingDetails() {
      let new_data = {
        allModuleId: this.ALLMODULE,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Tracking/getSubscriptionTrackingDetails.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if (status == 200 && data) {
            if (data.BIdType && data.BIdType.length > 0) {
              this.$sessionsStorage.set("trackingId", data.BIdType[0].id);
              this.trackingId = data.BIdType[0].id;
            } else {
              this.trackingId = "";
            }
            this.getSubscription();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style>
.mobile-btn-booking {
  margin-top: 39px !important;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  .mobile-btn-booking {
    margin-top: 10px !important;
  }
}

.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffBooking.vue?ce180d1c